import Navigation from '@/components/Navigation'
import { usePageMeta } from '@/hooks/usePageMeta'
import Hero from '@/components/Hero'
import TrailerSection from '@/components/TrailerSection'
import DictionarySection from '@/components/DictionarySection'
import LogosSection from '@/components/LogosSection'
import StorySection from '@/components/StorySection'
import RudySection from '@/components/RudySection'
import VictimSection from '@/components/VictimSection'
import Footer from '@/components/Footer'
import { LightboxProvider } from '@/components/Lightbox'

const HomePage = () => {
  usePageMeta({
    title: 'SPOKE | When the Bravest People You Know Are the Ones in Trouble',
    description: 'A cinematic descent into the occupational health crisis inside firehouses — cancer, PTSD, and the fight to change what happens next.',
  })
  return (
    <LightboxProvider>
      <Navigation />
      <Hero />
      <TrailerSection />
      <DictionarySection />
      <LogosSection />
      <StorySection />
      <RudySection />
      <VictimSection />

      <Footer />
    </LightboxProvider>
  )
}

export default HomePage
